export const hasIncorrectRounding = (arr) => {
    return arr.map(obj => Object.values(obj)).flat().some(item => item.toString().split('.')[1]?.length > 1)    ; 
  }